/**
 * Un même scan peut arriver deux fois sur le PDA : par l'adresse de lancement envoyée par
 * l'appli TPE (?code=…) et par le clavier émulé du service de scan. Dans les 3 s, le second
 * est ignoré. Deux scans clavier du même article restent comptés (réception, inventaire).
 */
export type ScanSource = 'launch' | 'keyboard';

type Stamp = { code: string; at: number };

export const DUPLICATE_WINDOW_MS = 3000;

const recent: Record<ScanSource, Stamp | null> = { launch: null, keyboard: null };

/** Vrai si le code doit être traité ; faux si l'autre voie vient de l'apporter. */
export const acceptScan = (code: string, source: ScanSource, now = Date.now()): boolean => {
  const otherSource: ScanSource = source === 'launch' ? 'keyboard' : 'launch';
  const other = recent[otherSource];
  if (other && other.code === code && now - other.at < DUPLICATE_WINDOW_MS) {
    // Un seul doublon écarté : le scan suivant du même article compte normalement.
    recent[otherSource] = null;
    return false;
  }
  recent[source] = { code, at: now };
  return true;
};

/** Pour les tests. */
export const resetScanSources = (): void => {
  recent.launch = null;
  recent.keyboard = null;
};
